// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__33gPW","clinicsSelect":"TableHeading_clinicsSelect__3tcJR"};